import { createFileRoute } from '@tanstack/react-router';

import { ProjectSearchClaimable } from '@/module/Author/Project/ProjectSearchClaimable';

export const Route = createFileRoute('/_auth/author/_author/project/_project/search-claimable')({
  component: ProjectSearchClaimable,
  staticData: {
    pageTitle: { id: 'pageTitle.create' },
  },
});
